import React from "react";

function ArrowOutwardIcon() {

  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="#FFF">
      <path d="m242-246-42-42 412-412H234v-60h480v480h-60v-378L242-246Z"/>
    </svg>
  )

}

export default React.memo(ArrowOutwardIcon);